import { cloneDeep } from 'lodash'
import { ThreadLista } from '../api/types';
import { COMPETENZA_COLORS } from '../globals';
import { Competenza } from '../api/auto-types';

/**
 * Questa funzione fa zero padding dei numeri.
 * pad(13, 4) = 0013
 * pad(13, 4, 2) = 2213
 */
export function pad(n: string, width: number, z?: string): string {
  z = z || '0';
  n = n + '';
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}



/**
 * Equivalente del python string.join
 */
export const str_join: (vec: string[], char: string) => string = (vec, char) => {
  if (vec.length == 0) {
    return ""
  } else if (vec.length > 1) {
    return vec[0] + char + str_join(vec.slice(vec.length - 1), char);
  } else {
    return vec[0];
  }
}



export function reverseString(str: string): string {
  return str.split("").reverse().join("")
}



export const fixed_or_null = (cusu: number) => {
  if (cusu) {
    return cusu.toFixed(2);
  } else {
    return cusu;
  }
}


// Array Remove - By John Resig (MIT Licensed)
export const array_remove = <T>(array: T[], from: number, to?: number) => {
  if (!to) { to = from }
  let rest = array.slice((to || from) + 1 || array.length);
  array.length = from < 0 ? array.length + from : from;
  array.push.apply(array, rest);
  return array;
};



interface Versioned {
  versioni?: any[]
}

export const deserialize_versioned = (orig: Versioned) => {
  const copied = cloneDeep(orig)

  if (copied.hasOwnProperty("versioni") && copied.versioni !== undefined && copied.versioni.length > 0) {
    const content = copied.versioni[0];
    delete copied.versioni;
    return {
      ...content,
      ...copied,
    }
  }
  return copied
}


export const get_problemi_buoni = (problems: ThreadLista[]) => {
  const problemi_non_assegnati = problems.filter(item => !item.problema.evento_assegnato);
  const problemi_buoni = problemi_non_assegnati.filter(item => !item.problema.flags_smistatore || !["r", "s", "d"].includes(item.problema.flags_smistatore.flag));
  return problemi_buoni
}


export const displayCompetenzaColore = (obj: Competenza["tipologia"]) => COMPETENZA_COLORS[obj];
